module.exports = __webpack_public_path__ + "static/media/MicrosoftEdge_Copilot.2adbebc0.png";